import { formatCarNumber } from '../format/formatCarNumber'
import { typeEmpty } from '../type/typeEmpty'

/**
 * @desc 验证是否数字格式
 * @param {boolean} required
 * @param {String} validateValue
 * @param {*} callback
 * @param {String} field
 * @param {String} [action]
 */
export const vCarNumber = (required: boolean, validateValue: string, callback: any, field: string, action: string = '填写'): void => {
  if (!required && !validateValue) {
    callback()
  } else {
    if (typeEmpty(validateValue)) {
      action = action || '填写'
      callback(new Error(`${field}必须${action}`))
    } else {
      if (formatCarNumber(validateValue)) {
        callback()
      } else {
        callback(new Error(`${field}必须是车牌号码`))
      }
    }
  }
}
